<template>
  <div class="body">
    <div class="section wf-section"></div>
    <div class="section-2 last wf-section">
      <div class="container w-container">
        <p class="paragraph">
          dublab is a Los Angeles-based, community-supported internet radio
          station and creative collective dedicated to the growth of positive
          music, arts, and culture. Founded in 1999, dublab has been
          broadcasting since the “dot-com era” with the mission to share
          forward-thinking, freeform radio with an international audience.
          dublab’s programming has since expanded to include the production of
          original art exhibits, films, television, events, and community
          education projects as well as broadcast on affiliate stations in
          Germany, Japan, Spain, and Brazil.<br /><br />Each month, dublab
          showcases over 180 radio shows from some of the world’s most talented
          DJs, musicians, journalists, and artists. Each show is distinct and
          entirely freeform: we take pride in empowering our DJs to freely play
          the music that best shares their individual story. Beyond broadcast,
          dublab produces and hosts several multimedia projects and exhibits
          each year, most often made possible by the support of public and
          foundation project grants. Through local events, international
          broadcasts, and collaborative multimedia projects, dublab has helped
          define and connect the next wave of arts, music, and culture across
          the Los Angeles and international communities.
        </p>
        <div class="mission-statement">
          <div class="text-block text-block-2">Mission statement</div>
          <p class="paragraph-3">
            dublab cultivates and supports local cultural ecosystems worldwide. 
            Through community-generated radio, dublab expands curiosity, 
            experimentation, inclusivity, education and connection.
          </p>
        </div>
        <div class="directory-row">
          <div class="text-block-3">about</div>
          <div class="img-row">
            <a href="/aboutdetail" class="link-block-2 w-inline-block">
              <div class="img-holder">
                <div class="text-block-4">Core Values</div>
                <img
                  src="@/assets/images/9.png"
                  loading="lazy"
                  alt=""
                  class="image"
                />
              </div>
            </a>
            <a href="/aboutdetail#dei" class="link-block-2 w-inline-block">
              <div class="img-holder">
                <div class="text-block-4">DEI Statement</div>
                <img
                  src="@/assets/images/1.png"
                  loading="lazy"
                  alt=""
                  class="image"
                />
              </div>
            </a>
            <a href="/aboutdetail#history" class="link-block-2 w-inline-block">
              <div class="img-holder">
                <div class="text-block-4">History</div>
                <img
                  src="@/assets/images/history.png"
                  loading="lazy"
                  alt=""
                  sizes="(max-width: 479px) 27vw, (max-width: 767px) 26vw, 21vw"
                  srcset="
                    @/assets/images/history-p-500.png  500w,
                    @/assets/images/history-p-800.png  800w,
                    @/assets/images/history.png       1000w
                  "
                  class="image-3"
                />
              </div>
            </a>
          </div>
        </div>
        <div class="directory-row">
          <div class="text-block-3">Our Team</div>
          <div class="img-row">
            <a href="/team" class="link-block-2 w-inline-block">
              <div class="img-holder">
                <div class="text-block-4">Staff</div>
                <img
                  src="@/assets/images/staff.png"
                  loading="lazy"
                  alt=""
                  sizes="(max-width: 479px) 100vw, 21vw"
                  srcset="
                    @/assets/images/staff-p-500.png   500w,
                    @/assets/images/staff-p-800.png   800w,
                    @/assets/images/staff-p-1080.png 1080w,
                    @/assets/images/staff.png        1200w
                  "
                  class="image"
                />
              </div>
            </a>
            <a href="/team#directors" class="link-block-2 w-inline-block">
              <div class="img-holder">
                <div class="text-block-4">Board of Directors</div>
                <img
                  src="@/assets/images/core_values.png"
                  loading="lazy"
                  alt=""
                  sizes="(max-width: 479px) 100vw, 21vw"
                  srcset="
                    @/assets/images/core_values-p-500.png 500w,
                    @/assets/images/core_values-p-800.png 800w,
                    @/assets/images/core_values.png       800w
                  "
                  class="image"
                />
              </div>
            </a>
            <a href="/team#supporters" class="link-block-2 w-inline-block">
              <div class="div-block-2">
                <div class="text-block-4">Donors and Supporters</div>
                <img
                  src="@/assets/images/6.png"
                  loading="lazy"
                  alt=""
                  class="image-3"
                />
              </div>
            </a>
          </div>
        </div>
        <div class="directory-row">
          <div class="text-block-3">Support Dublab</div>
          <div class="img-row">
            <a href="/supporters" class="link-block-2 w-inline-block">
              <div class="img-holder">
                <div class="text-block-4">Become a Major Donor</div>
                <img
                  src="@/assets/images/1.png"
                  loading="lazy"
                  alt=""
                  class="image"
                />
              </div>
            </a>
            <a href="/supporters#supporter-circle" class="link-block-2 w-inline-block">
              <div class="img-holder">
                <img
                  src="@/assets/images/circle_overlay.jpg"
                  loading="lazy"
                  alt=""
                  class="image-17"
                />
                <div class="text-block-4-copy">Join our Supporter Circle</div>
              </div>
            </a>
            <a href="/supporters#sponsor" class="link-block-2 w-inline-block">
              <div class="img-holder">
                <div class="text-block-4">
                  Sponsorship &amp; <br />Underwriting
                </div>
                <img
                  src="@/assets/images/3.png"
                  loading="lazy"
                  alt=""
                  class="image"
                />
              </div>
            </a>
           
          </div>
        </div>
        <div class="img-row-copyer">
          <a href="/support/memberships" class="link-block-2 w-inline-block">
            <div class="div-block-2">
              <div class="text-block-4">Membership</div>
              <img
                src="@/assets/images/5.png"
                loading="lazy"
                alt=""
                class="image-3"
              />
            </div>
          </a>
          <a
            href="https://shop.dublab.com/products/dublab-donation"
            class="link-block-2 w-inline-block"
          >
            <div class="img-holder">
              <img
                src="@/assets/images/7.png"
                loading="lazy"
                alt=""
                class="image-16"
              />
              <div class="text-block-4-copy">
                Make a one time <br />donation
              </div>
            </div>
          </a>
          <a href="/supporters#other" class="link-block-2 w-inline-block">
            <div class="img-holder">
              <img
                src="@/assets/images/9.png"
                loading="lazy"
                alt=""
                class="image-17"
              />
              <div class="text-block-4-copy">Other ways to support</div>
            </div>
          </a>
        </div>
        <a
          href="https://shop.dublab.com"
          target="_blank"
          class="link-block w-inline-block"
        >
          <div class="mission-statement-copy">
            <div class="div-block-3">
              <img
                src="@/assets/images/dubMerch.png"
                loading="lazy"
                class="image-4"
              />
            </div>
            <p class="paragraph-3">
              Visit our shop to explore our collection of T-shirts, hoodies,
              stickers, and more.
            </p>
          </div>
        </a>
        <div class="div-block-4">
          <div class="text-block-5">Contact us</div>
          <div class="div-block-5">
            <div class="div-block-6">
              <p class="paragraph-4">
                dublab<br />1035 West 24th Street<br />Los Angeles, CA 90007
              </p>
            </div>
            <div class="div-block-6">
              <p class="paragraph-4">
                General inquiries and promotional materials:<br />‍<br /><a
                  href="mailto:info@dublab.com"
                  >info@dublab.com</a
                >
              </p>
            </div>
            <div class="div-block-6">
              <p class="paragraph-4">
                Donations:<br /><a href="mailto:donate@dublab.com"
                  >donate@dublab.com</a
                ><br />‍<br />Technical Assistance:<br /><a
                  href="mailto:webops@dublab.com"
                  >webops@dublab.com</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
};
</script>

<style scoped>
.section {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 60vh;
  max-height: 800px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-image: url("..//assets/images/dublab_front_with_logo.jpg");
  background-position: 50% 75%;
  background-size: cover;
}

.container {
  max-width: 66%;
  margin: 0 auto;
  margin-top: 80px;
}

.container.mission {
  margin-top: 0px;
}

.paragraph {
  width: 70%;
  margin-right: auto;
  margin-bottom: 0px;
  margin-left: auto;
  font-family: Suisseneue, sans-serif;
  font-size: 18px;
  line-height: 25px;
}

.mission-statement {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 340px;
  margin-top: 60px;
  margin-bottom: 40px;
  border: 1px solid #000;
  border-radius: 40px;
  font-family: Adieu, sans-serif;
  font-size: 36px;
  line-height: 40px;
  font-weight: 300;
  text-align: center;
}

.text-block {
  font-family: Suisseintlmono, sans-serif;
  font-size: 16px;
  line-height: 18px;
  font-weight: 400;
  text-transform: uppercase;
}

.text-block-2 {
  font-size: 14px;
  margin-top: -2rem;
}

.paragraph-2 {
  max-width: 65%;
}

.paragraph-3 {
  width: 75%;
  margin-top: 10px;
  margin-right: auto;
  margin-left: auto;
  padding-left: 40px;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  -ms-grid-row-align: center;
  align-self: center;
  font-size: 22px;
  line-height: 38px;
}

.directory-row {
  margin-bottom: 60px;
  border-top: 1px solid #000;
  font-size: 13px;
}

.text-block-3 {
  margin-top: 10px;
  margin-bottom: 10px;
  font-family: Suisseintlmono, sans-serif;
  text-transform: uppercase;
  text-align: left;
}

.img-row {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: 0px;
  padding-top: 0px;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.img-holder {
  position: relative;
  height: 180px;
  margin-right: 2%;
  -webkit-align-self: auto;
  -ms-flex-item-align: auto;
  -ms-grid-row-align: auto;
  align-self: auto;
  -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto;
  border-style: none;
  border-width: 1px;
  border-color: transparent;
  border-radius: 12px;
  text-align: left;
}

.div-block-2 {
  position: relative;
  height: 180px;
  -o-object-fit: none;
  object-fit: none;
}

.image {
  max-height: 100%;
  min-width: 100%;
  border-radius: 15px;
  -o-object-fit: cover;
  object-fit: cover;
}

.image-2 {
  display: inline-block;
  max-height: 100%;
  min-height: 100%;
  min-width: 100%;
  border-radius: 15px;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%;
}

.image-3 {
  max-height: 100%;
  min-width: 100%;
  border-radius: 15px;
  -o-object-fit: cover;
  object-fit: cover;
}

.text-block-4 {
  position: absolute;
  left: 0%;
  top: 0%;
  right: auto;
  bottom: auto;
  display: inline-block;
  margin-top: 10px;
  margin-left: 15px;
  float: none;
  clear: left;
  font-family: Adieu, sans-serif;
  color: #fff;
  font-size: 18px;
  line-height: 24px;
  cursor: pointer;
}

.mission-statement-copy {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 340px;
  margin-top: 60px;
  margin-bottom: 40px;
  padding: 30px;
  border: 1px dashed #000;
  border-radius: 30px;
  font-family: Adieu, sans-serif;
  font-size: 36px;
  line-height: 40px;
  font-weight: 300;
  text-align: center;
}

.div-block-3 {
  width: 33%;
}

.image-4 {
  height: auto;
  max-height: 100%;
  min-height: 100%;
  min-width: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}

.link-block {
  color: #000;
  text-decoration: none;
}

.div-block-4 {
  height: 180px;
  border-top: 1px solid #000;
  border-radius: 1px;
}

.section-2 {
  border: 1px none #000;
}

.text-block-5 {
  margin-top: 10px;
  margin-bottom: 10px;
  font-family: Suisseintlmono, sans-serif;
  text-transform: uppercase;
  text-align: left;
  font-size: 13px;
}

.div-block-5 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  grid-column-gap: 5%;
  grid-row-gap: 5%;
}

.paragraph-4 {
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  -ms-grid-row-align: center;
  align-self: center;
  -webkit-box-ordinal-group: 0;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
}

.div-block-6 {
  width: 30%;
  text-align: left;
  font-family: Adieu, sans-serif;
  font-size: 20px;
  line-height: 24px;
  font-weight: 300;
}

.image-5 {
  width: 100%;
  margin-top: 60px;
}

.paragraph-5 {
  font-family: Adieu, sans-serif;
  color: #fff;
  font-size: 80px;
  line-height: 70px;
  text-transform: none;
  text-shadow: 0 0 6px #000;
}

.heading {
  margin-top: 0px;
  margin-bottom: 20px;
  margin-left: auto;
  font-family: Adieu, sans-serif;
  font-size: 32px;
  line-height: 40px;
  font-weight: 300;
}

.heading.yearly {
  font-weight: 400;
}

.body {
  margin-right: auto;
  text-align: center;
}

.div-block-7 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 20px;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-content: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  grid-column-gap: 2.5%;
  grid-row-gap: 2.5%;
}

.div-block-8 {
  display: block;
  width: 23%;
  height: 15%;
  max-height: 15%;
  max-width: none;
  min-height: 15%;
  min-width: 150px;
  margin-right: 0%;
  margin-bottom: 40px;
  -webkit-box-ordinal-group: 2;
  -webkit-order: 1;
  -ms-flex-order: 1;
  order: 1;
  -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto;
}

.div-block-9 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  height: 120%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-align: baseline;
  -webkit-align-items: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
  -webkit-align-content: space-around;
  -ms-flex-line-pack: distribute;
  align-content: space-around;
}

.paragraph-6 {
  margin-top: 10px;
  font-family: Adieu, sans-serif;
  font-size: 16px;
  line-height: 20px;
  font-weight: 300;
  text-align: left;
}

.div-block-10 {
  margin-bottom: 50px;
  border-top: 1px solid #000;
}

.paragraph-7 {
  font-family: Adieu, sans-serif;
  color: #fff;
  font-size: 84px;
  line-height: 90px;
  font-weight: 300;
  text-align: center;
}

.aboutsection {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 55vh;
  max-height: 800px;
  margin-bottom: -70px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-image: url("../assets/images/Jeremiah-Chiu---Zoom-Room-2.jpg");
  background-position: 50% 50%;
  background-size: cover;
  background-clip: border-box;
  -webkit-text-fill-color: inherit;
}

.section-copy {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 55vh;
  max-height: 800px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-image: url("../assets/images/Dublab-4.jpg");
  background-position: 50% 70%;
  background-size: cover;
}

.section-copy-copy {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  overflow: visible;
  height: 55vh;
  max-height: 800px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: transparent;
  background-image: url("../assets/images/dublab_blues.png");
  background-position: 50% 50%;
  background-repeat: repeat;
  background-attachment: scroll;
  -o-object-fit: fill;
  object-fit: fill;
}

.paragraph-8 {
  margin-top: -50px;
  padding-top: 0px;
  font-family: Adieu, sans-serif;
  color: #fff;
  font-size: 80px;
  line-height: 90px;
}

.image-6 {
  background-color: transparent;
  -webkit-filter: invert(100%);
  filter: invert(100%);
}

.image-7 {
  position: absolute;
  left: auto;
  top: auto;
  right: 0%;
  bottom: 0%;
}

.image-8 {
  overflow: auto;
  -o-object-fit: cover;
  object-fit: cover;
}

.flexycontainer {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 60px;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-align-content: space-between;
  -ms-flex-line-pack: justify;
  align-content: space-between;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 30px;
  -ms-grid-columns: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  -ms-grid-rows: auto auto;
  grid-template-rows: auto auto;
}

.flexycontainer.rogueflex {
  width: 725.3359375px;
  margin-right: auto;
  margin-bottom: 80px;
  margin-left: auto;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
}

.flexycontainer.mids {
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.logoholder {
  position: relative;
  overflow: visible;
  width: 28%;
  margin-bottom: 20px;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  -ms-grid-row-align: center;
  align-self: center;
  -o-object-fit: fill;
  object-fit: fill;
}

.image-9 {
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 100%;
  margin-bottom: 20px;
  padding-bottom: 0px;
  -o-object-fit: cover;
  object-fit: cover;
}

.image-10 {
  background-color: transparent;
  -webkit-filter: invert(100%);
  filter: invert(100%);
}

.image-11 {
  max-height: 80%;
  margin-top: 0px;
  margin-right: auto;
  margin-left: auto;
  padding-top: 0px;
  -webkit-filter: invert(100%);
  filter: invert(100%);
}

.text-block-6 {
  font-family: Suisseneue, sans-serif;
  font-size: 24px;
  line-height: 40px;
  font-weight: 300;
}

.text-block-7 {
  font-family: Suisseneue, sans-serif;
  font-size: 24px;
  line-height: 40px;
  font-weight: 300;
}

.div-block-11 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-weight: 400;
}

.div-block-12 {
  -webkit-align-self: auto;
  -ms-flex-item-align: auto;
  -ms-grid-row-align: auto;
  align-self: auto;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.div-block-13 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.div-block-14 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.grid {
  display: -ms-grid;
  display: grid;
  min-width: 100%;
  grid-auto-flow: row;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-areas: "Area";
  -ms-grid-columns: 1fr 16px 1fr;
  grid-template-columns: 1fr 1fr;
  -ms-grid-rows: auto 16px auto;
  grid-template-rows: auto auto;
}

.div-block-15 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 47%;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto;
}

.div-block-15.mids {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto;
}

.div-block-16 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 46%;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  align-self: center;
}

.div-block-17 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  max-width: 46%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.heading-2 {
  margin-top: 0px;
  font-family: Suisseintlmono, sans-serif;
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.paragraph-9 {
  font-family: Suisseneue, sans-serif;
  font-weight: 400;
  text-align: left;
}

.div-block-18 {
  width: 4%;
}

.container-2 {
  max-width: 66%;
}

.container-3 {
  max-width: 78%;
}

.image-13 {
  -webkit-filter: invert(100%);
  filter: invert(100%);
}

.heading-3 {
  margin-top: 0px;
  margin-bottom: 20px;
  font-family: Adieu, sans-serif;
  color: #333;
  font-weight: 300;
}

.image-14 {
  min-height: 100%;
  min-width: 100%;
}

.link-block-2 {
  width: 32%;
}

.container-4 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  max-width: 66%;
  margin-top: 80px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
}

.values {
  padding-top: 20px;
  padding-bottom: 20px;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  -ms-grid-row-align: center;
  align-self: center;
  -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto;
  font-family: Adieu, sans-serif;
  font-size: 34px;
  line-height: 50px;
  font-weight: 300;
}

.list-item {
  list-style-type: none;
}

.list {
  display: block;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  font-family: Suisseintlmono, sans-serif;
  list-style-type: decimal;
}

.corevalue {
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 22px;
}

.container-5 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.container-5.dei {
  margin-bottom: 0px;
}

.paragraph-10 {
  margin-bottom: 60px;
  font-family: Suisseneue, sans-serif;
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;
}

.div-block-19 {
  width: 100%;
  border-style: solid none none;
  border-width: 1px;
  border-color: #000;
  border-radius: 1px;
}

.list-item-2 {
  margin-bottom: 20px;
}

.fact {
  margin-bottom: 30px;
  font-family: Suisseintlmono, sans-serif;
  font-size: 16px;
  line-height: 22px;
}

.list-2 {
  padding-top: 24px;
  padding-bottom: 53px;
  font-family: Montserrat, sans-serif;
}

.list-2.gifst {
  margin-top: -40px;
}

.image-16 {
  position: static;
  height: 100%;
  max-height: 100%;
  min-width: 100%;
  border-radius: 15px;
  -o-object-fit: cover;
  object-fit: cover;
}

.image-17 {
  max-height: 100%;
  min-width: 100%;
  border-radius: 15px;
  -o-object-fit: cover;
  object-fit: cover;
}

.majordonor {
  font-family: Suisseneue, sans-serif;
  font-size: 20px;
  line-height: 28px;
}

.toggle {
  margin-top: 40px;
  padding: 40px 20px;
  border: 2px solid #000;
  border-radius: 12px;
  font-family: Adieu, sans-serif;
  font-size: 34px;
  line-height: 44px;
  text-transform: uppercase;
}

.lilp {
  width: 80%;
  margin-top: 60px;
  margin-right: auto;
  margin-left: auto;
  font-size: 32px;
}

.keep-us-on-air {
  display: block;
  height: 220px;
  margin-top: 60px;
  margin-bottom: 40px;
  border: 1px solid #000;
  border-radius: 40px;
  font-family: Adieu, sans-serif;
  font-size: 36px;
  line-height: 40px;
  font-weight: 300;
  text-align: center;
}

.div-block-20 {
  display: block;
  width: 100%;
  height: 30vh;
  max-width: 100%;
  min-width: 100px;
}

.image-18 {
  max-height: 100%;
  min-width: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.text-block-4-copy {
  position: absolute;
  left: 0%;
  top: 0%;
  right: auto;
  bottom: auto;
  display: inline-block;
  margin-top: 10px;
  margin-left: 15px;
  float: none;
  clear: left;
  font-family: Adieu, sans-serif;
  color: #fff;
  font-size: 18px;
  line-height: 24px;
  cursor: pointer;
}

.aboutsection-copy {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 55vh;
  max-height: 800px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: rgba(41, 89, 151, 0.8);
  background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(rgba(41, 107, 194, 0.7)),
      to(rgba(41, 107, 194, 0.7))
    ),
    url(".../assets/images/Dublab-3.jpg");
  background-image: linear-gradient(
      180deg,
      rgba(41, 107, 194, 0.7),
      rgba(41, 107, 194, 0.7)
    ),
    url("../assets/images/Dublab-3.jpg");
  background-position: 0px 0px, 50% 50%;
  background-size: auto, cover;
  background-clip: border-box;
  -webkit-text-fill-color: inherit;
}

.heading-3-copy {
  display: block;
  margin-top: 0px;
  margin-bottom: 20px;
  font-family: Adieu, sans-serif;
  color: gold;
  font-weight: 300;
  text-decoration: underline;
}

.heading-3-copy2 {
  margin-top: 0px;
  margin-bottom: 20px;
  font-family: Adieu, sans-serif;
  color: #9b9b9b;
  font-weight: 300;
  text-decoration: underline;
}

.heading-3-copy5 {
  margin-top: 0px;
  margin-bottom: 20px;
  font-family: Adieu, sans-serif;
  color: #b08d57;
  font-weight: 300;
  text-decoration: underline;
}

.text-block-8 {
  width: 80%;
  margin-bottom: 38px;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  -ms-grid-row-align: center;
  align-self: center;
  font-family: Adieu, sans-serif;
  font-weight: 300;
  text-align: center;
}

.img-row-copyer {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: -46px;
  padding-top: 0px;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.goldimg {
  display: none;
  width: 30%;
  max-width: 30%;
  margin-bottom: 54px;
}

@media screen and (max-width: 991px) {
  .paragraph {
    width: 100%;
  }

  .paragraph-3 {
    font-size: 20px;
    line-height: 33px;
  }

  .image-4 {
    min-height: 100%;
    -o-object-fit: scale-down;
    object-fit: scale-down;
  }

  .section-2 {
    line-height: 22px;
  }

  .paragraph-4 {
    font-size: 14px;
    line-height: 20px;
  }

  .flexycontainer.rogueflex {
    width: auto;
  }

  .div-block-15 {
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-align-self: auto;
    -ms-flex-item-align: auto;
    -ms-grid-row-align: auto;
    align-self: auto;
  }

  .div-block-15.mids {
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .div-block-17 {
    display: none;
  }

  .image-15 {
    -webkit-box-flex: 0;
    -webkit-flex: 0 auto;
    -ms-flex: 0 auto;
    flex: 0 auto;
  }

  .container-5.dei {
    max-width: 80%;
  }

  .container-5.history {
    max-width: 80%;
  }

  .image-16 {
    height: auto;
  }

  .lilp {
    margin-top: 0px;
    font-size: 30px;
    line-height: 38px;
  }

  .keep-us-on-air {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }
}

@media screen and (max-width: 767px) {
  .container {
    max-width: 80%;
  }

  .container.mission {
    max-width: 80%;
  }

  .mission-statement {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .text-block {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .paragraph-3 {
    padding-left: 0px;
    font-size: 17px;
    line-height: 25px;
  }

  .text-block-4 {
    font-size: 14px;
    line-height: 20px;
  }

  .div-block-4 {
    display: none;
    max-width: 100%;
    margin-right: auto;
    margin-left: auto;
  }

  .paragraph-4 {
    font-size: 12px;
    line-height: 16px;
  }

  .paragraph-5 {
    font-size: 60px;
  }

  .div-block-7 {
    -webkit-justify-content: space-around;
    -ms-flex-pack: distribute;
    justify-content: space-around;
  }

  .div-block-8 {
    min-width: 180px;
    -webkit-align-self: auto;
    -ms-flex-item-align: auto;
    -ms-grid-row-align: auto;
    align-self: auto;
    -webkit-box-flex: 0;
    -webkit-flex: 0 auto;
    -ms-flex: 0 auto;
    flex: 0 auto;
  }

  .paragraph-6 {
    font-size: 16px;
    line-height: 20px;
  }

  .container-2 {
    max-width: 80%;
  }

  .container-4 {
    max-width: 80%;
  }

  .container-5.history {
    max-width: 80%;
  }

  .paragraph-10 {
    max-width: 100%;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    -ms-grid-row-align: center;
    align-self: center;
  }

  .div-block-19 {
    width: 100%;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    -ms-grid-row-align: center;
    align-self: center;
  }

  .list-2 {
    max-width: 100%;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    -ms-grid-row-align: center;
    align-self: center;
  }

  .lilp {
    font-size: 26px;
    line-height: 34px;
  }

  .text-block-4-copy {
    font-size: 14px;
    line-height: 20px;
  }

  .heading-3-copy {
    display: block;
  }

  .goldimg {
    display: none;
  }

  .container-6 {
    max-width: 80%;
  }

  .container-7 {
    max-width: 80%;
  }
}

@media screen and (max-width: 479px) {
  .container {
    max-width: 85%;
  }

  .mission-statement {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .text-block {
    margin-top: 0px;
    margin-bottom: 20px;
  }

  .paragraph-3 {
    font-size: 16px;
    line-height: 19px;
  }

  .img-row {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: stretch;
    -webkit-align-items: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    -webkit-align-content: stretch;
    -ms-flex-line-pack: stretch;
    align-content: stretch;
  }

  .img-holder {
    height: auto;
  }

  .paragraph-5 {
    display: block;
    margin-right: auto;
    margin-left: auto;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-align-self: auto;
    -ms-flex-item-align: auto;
    -ms-grid-row-align: auto;
    align-self: auto;
    -webkit-box-flex: 0;
    -webkit-flex: 0 auto;
    -ms-flex: 0 auto;
    flex: 0 auto;
    font-size: 44px;
    line-height: 54px;
    text-align: center;
  }

  .heading {
    font-size: 28px;
  }

  .div-block-7 {
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .div-block-8 {
    width: 70%;
  }

  .flexycontainer {
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .logoholder {
    width: 100%;
  }

  .div-block-15 {
    width: 100%;
  }

  .values {
    font-size: 24px;
    line-height: 30px;
    text-align: center;
  }

  .container-5.dei {
    max-width: 80%;
  }

  .paragraph-10 {
    font-size: 18px;
    line-height: 24px;
  }

  .majordonor {
    font-size: 18px;
    line-height: 24px;
  }

  .lilp {
    font-size: 20px;
    line-height: 28px;
  }

  .text-block-4-copy {
    font-size: 12px;
    line-height: 16px;
  }

  .container-6 {
    display: none;
  }

  .container-7 {
    display: none;
    max-width: 95%;
  }
}

@font-face {
  font-family: "Adieu";
  src: url("../assets/fonts/Adieu-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Suisseintlmono";
  src: url("../assets/fonts/SuisseIntlMono-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Adieu";
  src: url("../assets/fonts/Adieu-Light.otf") format("opentype");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Suisseneue";
  src: url("../assets/fonts/SuisseNeue-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
</style>